export default __webpack_public_path__ + "img/23.asset.56c95e62.jpeg";